import axios from "axios";

import { KEY } from "./constant";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;
const BASE_URL = `${SERVER_URL}/login`;

async function sendOTPCode(msisdn) {
  try {
    const { data } = await axios.post(`${BASE_URL}/sendcode/`, {
      msisdn,
      key: KEY,
    });
    return { data };
  } catch (e) {
    throw e;
  }
}

async function verifyOTPCode({ msisdn, code }) {
  try {
    const { data } = await axios.post(`${BASE_URL}/verifycode/`, {
      msisdn,
      pass_code: code,
      key: KEY,
    });

    return data;
  } catch (e) {
    throw e;
  }
}

export default { sendOTPCode, verifyOTPCode };
